<!-- eslint-disable -->
<template lang="pug">
    .play-box
        template
            .warning(v-if="isNotPossibleToPlayWithFlashcardSetting")
                svg(
                    version='1.1'
                    xmlns='http://www.w3.org/2000/svg'
                    x='0px' y='0px' width='40px'
                    height='40px' viewbox='0 0 612 612'
                    style='enable-background:new 0 0 612 612;'
                    xml:space='preserve'
                )
                    rotation-icon
                div
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_changeDeviceForShulte') }}
            template(v-else)
                template(v-if="!isLoading && !prepareForGame")
                    game-header(
                        v-if="!isBattle",
                        @soundStateChanged="headerKey = !headerKey",
                        :key="headerKey",
                        :time="getTime",
                        :slug="type",
                        :game-type="parameters && parameters.courseType",
                        :is-homework="!!exerciseId",
                    )
                    .play-box__game(
                        v-if="(!gameFinished || isBattle) && gameStarted && !isNextExampleButtonShown"
                        :class="{'play-box__game--tables': parameters.amountOfTables > 1}"
                    )
                        .play-box__game-container(
                            :style="{'flex-direction': isRow ? 'row' : 'column'}"
                            )
                            .play-box__example(
                                v-for="(table, index) in parameters.amountOfTables"
                                :key="table"
                            )
                                .play-box__header(:class="{'play-box__header--invisible': !canFindNumberInThisTable(index)}")
                                    | {{ $i18n.t('trainer.trainer_games_findTheNumber') }}:
                                    | {{ searchNumber }}
                                    span(
                                        v-if="parameters.redAndBlack && searchColor && canFindNumberInThisTable(index)"
                                        v-html="$i18n.t('trainer.trainer_games_withColor', {color: searchColor, trColor: $i18n.t('trainer.trainer_games_' + searchColor)})"
                                    )
                                schulte-table(
                                    :schulte-table="schulteTables[index]"
                                    :table-id="index"
                                    @handleClick="handleClick"
                                    :class="{'inverted': parameters.invertedTable}"
                                    :is-colored="parameters.redAndBlack"
                                    :is-flash-cards="parameters.flashCards"
                                    :is-tenth="parameters.tenth"
                                    :disabled="!canFindNumberInThisTable(index)"
                                )
                        .game-info__container(v-if="isBattle")
                            .game-info__block
                                game-info(
                                    :score="{left: userScore, right: opponentScore}",
                                    :time="getTime",
                                    :is-from-battle="isBattle",
                                    :parameters="parameters",
                                    :opponent="opponent",
                                    :opponent-tables="schulteTables",
                                    :is-opponent-answering="isOpponentAnswering",
                                )
                    calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
                    .play-box__end-container(v-if="(gameFinished && !isOlympiad && !isBattle) || isNextExampleButtonShown")
                        fireworks(
                            v-if="gameFinished && !isOlympiad"
                            :is-mobile="isMobile"
                        )
                        .play-box__reaction-container
                            .play-box__time(v-if="!isNextExampleButtonShown")
                                | {{ timeExecutionString }}
                            result-image.play-box__image(status="success")
                        result-buttons(
                            :exercise-id="exerciseId"
                            :games-type="parameters.courseType"
                            show-restart-button
                            @restartGame="restartGame"
                        )
                            template(slot="mainButton")
                                cs-button.play-box__button(
                                    v-if="isNextExampleButtonShown"
                                    color="blue"
                                    @click="getExample"
                                    v-focus=""
                                )
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                            slot
                game-preparation-counter(v-else-if="counter < 4", :counter="counter")
</template>

<script>
    /*eslint-disable*/
    import SchulteTable from './SchulteTable.vue';
    import _ from 'lodash';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import EndGameMixin from '../../../../utils/trainer/endGame';
    import Battle from '../../../../utils/battle/battleMixin';
    import GamePreparationCounter from '../../GamePreparationCounter.vue';
    import GameHeader from '../../GameHeader.vue';
    import GameInfo from '../GameInfo.vue';
    import Fireworks from '../Fireworks.vue';
    import RotationIcon from '../../../../components/svg/RotationIcon.vue';
    import ResultImage from '../ResultImage.vue';
    import CalculatingAnswers from "../../CalculatingAnswersModal.vue";
    import MobileDetect from "mobile-detect";


    const DEFAULT_VOLUME = 0.6;
    const DIRECT_MODE = 'direct';
    const MIXED_MODE = 'mixed';
    const RED_COLOR = 'red';
    const BLACK_COLOR = 'black';

    function DEFAULT_DATA () {
        return {
            schulteTables: [],
            schulteTableCells: [],
            amountOfNumbers: null,
            searchNumber: null,
            badAnswers: 0,
            goodAnswers: 0,
            prepareForGame: true,
            correctAnswersAmount: 0,
            searchNumbers: [],
            prevTableId: -1,
            searchColor: BLACK_COLOR,
            lastAnswer: null,
            amountOfExamples: 0,
            isNextExampleButtonShown: false,
            canFindNumberInFirstTable: true,
            headerKey: false,
            isSearchNumberInFirstTable: true,
            infinityModeCompleted: false,
            isRow: false,
        }
    }

    export default {
        props: {
            isLastGameInBattle: {
                type: Boolean,
                default: false
            }
        },
        mixins: [playBoxGameMixin, olympiadAnswerTimerMixin, Battle, EndGameMixin],
        created() {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        mounted () {
            window.addEventListener('resize', this.getCurrentWindowOrientation);
            this.getCurrentWindowOrientation();
            this.fetchData();
        },
        beforeDestroy() {
            this.beforeTabClosed();
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        watch: {
            'searchNumber'(newValue, oldValue) {
                newValue !== oldValue && this.setIsSearchNumberInFirstTable();
            },
            'searchColor'(newValue, oldValue) {
                newValue !== oldValue && this.setIsSearchNumberInFirstTable();
            },
            'prevTableId'(newValue, oldValue) {
                newValue !== oldValue && this.setIsSearchNumberInFirstTable();
            }
        },
        data () {
            return DEFAULT_DATA();
        },
        methods: {
            getCurrentWindowOrientation() {
                this.isRow = window.innerWidth > window.innerHeight;
            },
            fetchData () {
                this.getExercise()
                .then(() => {
                    this.assignDataFromParameters();
                    this.registerSounds();
                })
                .catch(e => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({name: 'dashboard'});
                })
            },
            beforeStart () {
                this.prepareForGame = false;
                this.gameStarted = true;
                !this.timer && this.setTimer();
                this.$nextTick(() => {
                    let collectionOfTableCells = document.querySelectorAll('.schulte-table__press-item');
                    this.schulteTableCells = _.chunk(collectionOfTableCells, this.parameters.difficult);
                    if (this.parameters.amountOfTables === 2) {
                        this.schulteTableCells = _.chunk(this.schulteTableCells, this.schulteTableCells.length / 2)
                    }
                });
                this.parameters.withTime && !this.amountOfExamples && (this.showNewLink());
            },
            assignDataFromParameters () {
                this.amountOfNumbers = this.parameters.difficult * this.parameters.difficult * this.parameters.amountOfTables;
                this.gameMode = this.parameters.mode;
                let lastNumber = this.parameters.redAndBlack && this.parameters.amountOfTables !== 2
                        ? Math.round(this.amountOfNumbers / this.parameters.amountOfTables / 2)
                        : this.amountOfNumbers / this.parameters.amountOfTables;
                this.searchNumber = this.gameMode === DIRECT_MODE || this.gameMode === MIXED_MODE ? 1 : lastNumber;
                if (this.parameters.tenth) {
                    this.amountOfNumbers = this.parameters.tenth ? this.amountOfNumbers * 10 : this.amountOfNumbers;
                    this.searchNumber = this.parameters.tenth ? this.searchNumber * 10 : this.searchNumber;
                }
                if (this.gameMode === MIXED_MODE) {
                    if (this.parameters.tenth) {
                        let begin = 1, end = this.amountOfNumbers / 10 / this.parameters.amountOfTables;
                        for (let i = 0; i < this.amountOfNumbers / 10; i++) {
                            this.searchNumbers.push((i % 2) ? 10 * end-- : 10 * begin++);
                        }
                    } else {
                        let begin = 1, end = this.amountOfNumbers / this.parameters.amountOfTables;
                        for (let i = 0; i < this.amountOfNumbers; i++) {
                            this.searchNumbers.push((i % 2) ? end-- : begin++);
                        }
                    }
                }
                this.schulteTables = Array(this.parameters.amountOfTables).fill([]);
                for (let i = 0; i < this.schulteTables.length; i++) {
                    this.schulteTables[i] = this.generateSchulteTable(i);
                }
                this.setIsSearchNumberInFirstTable();
                if (!this.timer && !this.prepareForGame) {
                    this.setTimer();
                }
                if (this.answerDuration) {
                    this.startAnswerTimer();
                }
            },
            generateSchulteTable (tableIndex = 0) {
                let lengthOfSide = this.parameters.difficult;
                let arrayLength = this.parameters.tenth ? this.amountOfNumbers / 10 / this.parameters.amountOfTables
                        : this.amountOfNumbers / this.parameters.amountOfTables;
                let arrayOfNums = new Array(arrayLength);
                let color;
                for (let index = 0, number = 1; index < arrayLength; index++) {
                    if (!this.parameters.redAndBlack) {
                        arrayOfNums[index] = {number: this.parameters.tenth ? 10 * number++ : number++}
                    } else if (this.parameters.amountOfTables < 2) {
                        color = index % 2 ? RED_COLOR : BLACK_COLOR;
                        arrayOfNums[index] = {number: this.parameters.tenth ? 10 * number : number, color: color};
                        index % 2 && number++;
                    } else {
                        if (tableIndex !== 0) {
                            color = !(index % 2) ? RED_COLOR : BLACK_COLOR;
                        } else {
                            color = (index % 2) ? RED_COLOR : BLACK_COLOR;
                        }
                        arrayOfNums[index] = {number: this.parameters.tenth ? 10 * number++ : number++, color: color};
                    }
                    arrayOfNums[index].status = false;
                }
                if (this.parameters.redAndBlack) {
                    this.lastAnswer = this.gameMode === DIRECT_MODE ? arrayOfNums[arrayOfNums.length - 1] : arrayOfNums[0];
                }
                arrayOfNums = _.shuffle(arrayOfNums);
                return _.chunk(arrayOfNums, lengthOfSide);
            },
            handleClick (cell, rowIndex, numIndex, tableId) {
                let clickedCell = this.parameters.amountOfTables !== 1
                        ? this.schulteTableCells[tableId][rowIndex][numIndex]
                        : this.schulteTableCells[rowIndex][numIndex];
                let isRightAnswer = false;
                if (this.parameters.redAndBlack) {
                    isRightAnswer = cell.number === this.searchNumber && cell.color === this.searchColor;
                } else {
                    isRightAnswer = cell.number === this.searchNumber;
                }
                isRightAnswer = isRightAnswer && !clickedCell.classList.contains('schulte-table__press-item_green');
                if (isRightAnswer) {
                    clickedCell.classList.add('schulte-table__press-item_green');
                    this.prevTableId = tableId;
                    this.schulteTables[tableId][rowIndex][numIndex].status = true;
                    if (this.gameMode !== MIXED_MODE) {
                        this.correctAnswersAmount++;
                        if (this.parameters.redAndBlack) {
                            this.handleCorrectAnswerWithColor();
                            return;
                        }
                        if (this.correctAnswersAmount === this.parameters.amountOfTables) {
                            if (this.parameters.tenth) {
                                this.searchNumber = this.gameMode === DIRECT_MODE ? this.searchNumber + 10 : this.searchNumber - 10;
                            } else {
                                this.gameMode === DIRECT_MODE ? this.searchNumber++ : this.searchNumber--;
                            }
                            this.goodAnswers++;
                            this.correctAnswersAmount = 0;
                        }
                    } else {
                        this.goodAnswers++;
                        this.parameters.redAndBlack && (this.searchColor = this.goodAnswers % this.amountOfNumbers % 2 ? RED_COLOR : BLACK_COLOR);
                        this.searchNumber = this.goodAnswers < this.searchNumbers.length
                                ? this.searchNumbers[this.goodAnswers]
                                : 0;
                        if (this.goodAnswers % this.amountOfNumbers === 0) {
                            this.searchNumber = 0;
                        } else if (this.goodAnswers % (this.amountOfNumbers / 10) === 0 && this.parameters.tenth) {
                            this.searchNumber = 0;
                        }
                    }
                    this.schulteTables[tableId][rowIndex][numIndex].status = true;
                    this.$createjs.Sound.play('clickCorrect')
                    if (this.searchNumber > this.amountOfNumbers / this.parameters.amountOfTables || this.searchNumber === 0) {
                        this.processReply();
                    }
                } else if (!clickedCell.classList.contains('schulte-table__press-item_green')) {
                    clickedCell.classList.add('shake', 'schulte-table__press-item_white');
                    this.badAnswers++;
                    this.$createjs.Sound.play('clickIncorrect');
                    setTimeout(() => {
                        clickedCell.classList.remove('shake', 'schulte-table__press-item_white');
                    }, 800)
                }
            },
            handleCorrectAnswerWithColor () {
                let prevColor = this.searchColor;
                this.goodAnswers++;
                if (this.parameters.tenth) {
                    this.searchColor = this.goodAnswers % (this.amountOfNumbers / 10) % 2 ? RED_COLOR : BLACK_COLOR;
                } else {
                    this.searchColor = this.goodAnswers % this.amountOfNumbers % 2 ? RED_COLOR : BLACK_COLOR;
                }
                if (this.parameters.amountOfTables === 1) {
                    let checkValue = this.parameters.tenth ? Math.round(this.amountOfNumbers / 10 / this.parameters.amountOfTables / 2) * 10
                            : Math.round(this.amountOfNumbers / this.parameters.amountOfTables / 2);
                    if (this.searchNumber === checkValue && this.parameters.difficult % 2 && this.correctAnswersAmount === 1) {
                        if (this.parameters.tenth) {
                            this.searchNumber = this.gameMode === DIRECT_MODE ? this.searchNumber + 10 : this.searchNumber - 10;
                        } else {
                            this.gameMode === DIRECT_MODE ? this.searchNumber++ : this.searchNumber--;
                        }
                        this.correctAnswersAmount = 0;
                    }
                    if (this.correctAnswersAmount > 1) {
                        if (this.gameMode === DIRECT_MODE) {
                            this.searchNumber = this.parameters.tenth ? this.searchNumber + 10 : this.searchNumber + 1;
                        } else {
                            this.searchNumber = this.parameters.tenth ? this.searchNumber - 10 : this.searchNumber - 1;
                        }
                        this.correctAnswersAmount = 0;
                    }
                } else {
                    if (this.correctAnswersAmount === this.parameters.amountOfTables) {
                        if (this.parameters.tenth) {
                            this.searchNumber = this.gameMode === DIRECT_MODE ? this.searchNumber + 10 : this.searchNumber - 10;
                        } else {
                            this.gameMode === DIRECT_MODE ? this.searchNumber++ : this.searchNumber--;
                        }
                        this.correctAnswersAmount = 0;
                    }
                }
                this.$createjs.Sound.play('clickCorrect');
                if (this.gameMode === DIRECT_MODE) {
                    if (this.parameters.difficult % 2 && this.parameters.amountOfTables !== 2) {
                        if (this.searchNumber >= this.lastAnswer.number && prevColor === this.lastAnswer.color) {
                            this.processReply();
                        }
                    } else if (this.searchNumber > this.lastAnswer.number) {
                        this.processReply();
                    }
                } else if (this.searchNumber === 0) {
                    this.processReply();
                }
            },
            processReply () {
                this.amountOfExamples += 1;
                if (this.parameters.numOfExamples <= this.amountOfExamples && !this.parameters.infinityAmountOfExamples) {
                    this.gameFinished = true;
                    this.stopTimer();
                } else {
                    this.stopTimer();
                    this.isNextExampleButtonShown = true;
                }
                this.sendStat();
                if (!this.isOlympiad) {
                    this.soundInstance = this.$createjs.Sound.play('gameDone');
                    this.soundInstance.volume = DEFAULT_VOLUME;
                }
            },
            getExample () {
                if (this.isNextExampleButtonShown) {
                    this.setTimer();
                    this.isNextExampleButtonShown = false;
                }
                this.schulteTableCells = null;
                this.assignDataFromParameters();
                this.$nextTick(this.beforeStart);
            },
            refreshGameStatBeforeSend () {
                this.gameStat.attempts = this.goodAnswers + this.badAnswers;
                this.gameStat.answers = this.goodAnswers;
                this.gameStat.chainOfAttempts = [];
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time !== 0 ? this.time : this.timeBeforeDestroy;
                this.gameStat.isCorrect = this.gameFinished;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
                if (this.parameters.infinityAmountOfExamples) {
                    this.gameStat.parameters.numOfExamples= this.amountOfExamples;
                }
                this.gameStat.infinityAmountOfExamples = this.parameters.infinityAmountOfExamples;
                this.gameStat.infinityModeCompleted = this.infinityModeCompleted;
            },
            calculatePercent () {
                let total = this.goodAnswers + this.badAnswers;
                if (total > 0) {
                    return parseInt(this.goodAnswers / (total) * 100);
                }
                return 0;
            },
            canFindNumberInThisTable (index) {
                return index === 0 ? this.isSearchNumberInFirstTable : !this.isSearchNumberInFirstTable;
            },
            setIsSearchNumberInFirstTable () {
              if (this.schulteTables.length !== 0) {
                this.isSearchNumberInFirstTable = this.schulteTables[0].some(row => {
                  return row.some(cell => {
                    return cell.number === this.searchNumber
                        && (this.gameMode !== MIXED_MODE || this.prevTableId !== 0)
                        && (!this.parameters.redAndBlack || cell.color === this.searchColor)
                        && !cell.status
                  })
                })
              }
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
            beforeTabClosed() {
                if (this.gameStarted && this.user.type === 'student' && !this.isBattle) {
                    this.gameFinished = true;
                    this.infinityModeCompleted = true;
                    this.sendStat(true);
                }
                return null;
            }
        },
        computed: {
            timeExecutionString () {
                if (!this.isOlympiad) {
                    return this.$i18n.t('progress.progress_table_executionTime') + ': '
                            + this.time + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_seconds', this.time);
                }
                return '';
            },
            isNotPossibleToPlayWithFlashcardSetting() {
                return this.parameters && this.parameters.flashCards &&
                    (Boolean(new MobileDetect(window.navigator.userAgent).tablet()) ||Boolean(new MobileDetect(window.navigator.userAgent).phone()))
            },
        },
        components: {
            Fireworks,
            GameInfo,
            GameHeader,
            GamePreparationCounter,
            SchulteTable,
            RotationIcon,
            CalculatingAnswers,
            ResultImage
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/sass/games/playbox.scss";

    .play-box {
        height: 100%;
    }

    .play-box--warning {
        display: table;
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .play-box__game {
        display: flex;
        justify-content: center;
        align-items: stretch;
        flex: 1 1 auto;
    }

    .play-box__game-container {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .play-box__game--tables {
        justify-content: center;
    }

    .play-box__example {
        height: 100%;
        display: flex;
        flex: 1 1 auto;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;
        padding: 0 10px;
        //style for battle
        width: 100%;
    }

    .play-box__header {
        font-size: 20px;
        line-height: 24px;
        font-weight: 500;
        margin-bottom: 10px;
        text-align: center;
        margin-top: 10px;
        height: 40px;
        @include media($xlg) {
            line-height: 38px;
            font-size: 24px;
        }
    }

    .play-box__header--invisible {
        color: transparent;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }

    .play-box__time {
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        color: $hsl-color-green-58;
        margin-bottom: 30px;
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        @include media($md) {
            font-size: 22px;
            line-height: 26px;
        }
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers-container {
        display: flex;
        width: 100%;
        justify-content: space-between;
        @include media($md) {
            display: none;
        }
    }

    .play-box__answers--good {
        color: $hsl-color-green-58;
        @include media($md) {
            margin-right: 20px;
        }
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--bad {
        color: $hsl-color-red-62;
        @include media($md) {
            margin-left: 20px;
        }
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--show-md {
        display: none;
        @include media($md) {
            display: block;
        }
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .inverted {
        transform: rotate(180deg);
    }
</style>
